jQuery(document).ready(function ($) {
    'use strict';

    $('.faq__category__item__headline').each(function () {

        $(this).on('click', function () {

            if ($(this).hasClass('fa-plus-circle')) {

                $(this).removeClass('fa-plus-circle');
                $(this).addClass('fa-minus-circle');

            } else {

                $(this).addClass('fa-plus-circle');
                $(this).removeClass('fa-minus-circle');

            }

            $(this).toggleClass('active');
            $(this).next().toggle();

        });

    });

});